export namespace ThreeDsTypes {
  export interface Meta {
    encodedBrowserMetadata: string;
    version?: string;
  }

  export interface PaymentSession {
    paymentSessionId: string;
    encodedConfig: string;
  }

  export enum SessionStatus {
    Success = 'SUCCESS',
    Failed = 'FAILED',
    Timeout = 'TIMEOUT',
    Error = 'ERROR',
  }

  export interface InitSessionResponse {
    statusCode: SessionStatus;
    message?: string;
  }

  export enum ProcessPhase {
    START,
    FINISH,
  }

  export interface DectaResponse {
    type: DectaStates;
    id: string;
  }

  export enum DectaStates {
    Success = 'success',
    Failure = 'failure',
    Cancelled = 'cancel',
  }

  export interface FrameState {
    show: boolean;
    source?: string;
    loading: boolean;
  }

  export enum Source {
    Expedia,
    Decta,
  }
}
